export type PolicyLang = 'en' | 'th' | 'ch';

export const POLICY_LANG_LABELS: Record<PolicyLang, string> = {
  en: 'English',
  th: 'ภาษาไทย',
  ch: '中文',
};

export const TERMS_CONTENT: Record<PolicyLang, string> = {
  th: `<div>
<h3 style="margin-top:0">เงื่อนไขการให้บริการ (Terms of use)</h3>
<p><strong>อัปเดตล่าสุดเมื่อ: [10 เมษายน 2026]</strong></p>
<p>เรียน ผู้ใช้บริการระบบ FROMAS ทุกท่าน</p>
<p>เพื่อยกระดับการให้บริการและเพื่อให้สอดคล้องกับมาตรฐานการจัดการซอฟต์แวร์ในปัจจุบัน ทาง บริษัท นิวซอฟท์เทคโนโลยี คอนซัลเทนท์ จำกัด ผู้ให้บริหารระบบ FROMAS ("ผู้ให้บริการ", "เรา", "บริษัท") ได้ทำการปรับปรุงข้อกำหนดและเงื่อนไขการให้บริการ (Terms &amp; Conditions) ฉบับใหม่ ข้อตกลงนี้มีผลผูกพันทางกฎหมายระหว่าง เรา และ ท่าน/โรงแรม ("ผู้ใช้บริการ", "ลูกค้า")</p>
<p>การที่ท่านคลิกยอมรับ หรือดำเนินการเข้าใช้งานระบบ FROMAS ต่อไป ถือว่าท่านได้อ่าน เข้าใจ และตกลงยอมรับข้อกำหนดและเงื่อนไขทั้งหมดที่ระบุไว้ด้านล่างนี้</p>
<ol>
  <li>
    <p><strong>ขอบเขตและรูปแบบการให้บริการ (Scope and Delivery of Service)</strong></p>
    <p>FROMAS เป็นผู้ให้บริการซอฟต์แวร์การจัดการโรงแรม (Property Management System - PMS) และบริการเสริมอื่นๆ เช่น ระบบจัดการช่องทางการจัดจำหน่าย (Channel Manager) ซอฟต์แวร์ถูกจัดเตรียมให้ในลักษณะ "ตามสภาพที่เป็นอยู่" (AS IS) โดยครอบคลุมรูปแบบการติดตั้ง 2 ประเภท ดังนี้:</p>
    <p><strong>1.1 สำหรับระบบแบบคลาวด์ (Cloud-based / SaaS):</strong><br/>เราให้บริการระบบผ่านเซิร์ฟเวอร์คลาวด์ที่เราดูแลผู้ใช้บริการมีหน้าที่จัดหาอุปกรณ์ และอินเทอร์เน็ตที่มีเสถียรภาพเพื่อเข้าใช้งาน เราจะรับผิดชอบในการบำรุงรักษา อัปเดตระบบ และสำรองข้อมูล (Backup) ตามมาตรฐานของเรา <br/>ทางบริษัท ขอสงวนความรับผิดในกรณีที่การบริการหรือซอฟท์แวร์ไม่สามารถใช้ได้โดยสาเหตุเกิดจากอุปกรณ์ของท่าน</p>
    <p><strong>1.2 สำหรับระบบแบบติดตั้งที่โรงแรม (On-Premise):</strong><br/>ระบบถูกติดตั้งลงบนฮาร์ดแวร์หรือเซิร์ฟเวอร์ของผู้ใช้บริการเอง ผู้ใช้บริการมีหน้าที่รับผิดชอบอย่างเต็มที่แต่เพียงผู้เดียว ในการดูแลรักษาระบบเครือข่ายภายใน, สภาพการทำงานของเครื่องเซิร์ฟเวอร์, การป้องกันไวรัส/มัลแวร์, และการตั้งค่าสำรองข้อมูล (Backup) ด้วยตนเอง</p>
    <ul>
      <li><strong>ก. กรณีเกิดความเสียหายจากมัลแวร์ (Ransomware/Malware):</strong> หากเซิร์ฟเวอร์ของท่านถูกโจมตีทางไซเบอร์ ติดไวรัส แรนซัมแวร์ หรือฮาร์ดแวร์ชำรุด จนส่งผลให้ข้อมูลสูญหายหรือระบบหยุดชะงัก FROMAS จะไม่รับผิดชอบใดๆ ทั้งสิ้น</li>
      <li><strong>ข. ค่าบริการนอกเหนือสัญญา MA:</strong> หากผู้ใช้บริการร้องขอให้ทีมงาน FROMAS ดำเนินการกู้คืนข้อมูล ซ่อมแซมฐานข้อมูล หรือติดตั้งระบบให้ใหม่จากเหตุดังกล่าว จะมี ค่าบริการทางเทคนิคเพิ่มเติม (Service Charge) ซึ่งอยู่นอกเหนือจากขอบเขตของสัญญาบริการบำรุงรักษารายปี (MA)</li>
    </ul>
    <p>ทางบริษัท ขอสงวนความรับผิดในกรณีที่การบริการหรือซอฟท์แวร์ไม่สามารถใช้ได้โดยสาเหตุเกิดจากอุปกรณ์ของท่าน</p>
  </li>
  <li>
    <p><strong>การใช้งานระบบจัดการโรงแรม (PMS) และความรับผิดชอบของลูกค้า</strong></p>
    <p><strong>2.1 ความถูกต้องของข้อมูล:</strong> ผู้ใช้บริการมีหน้าที่รับผิดชอบแต่เพียงผู้เดียวต่อความถูกต้องของข้อมูลทั้งหมดที่นำเข้าสู่ระบบ เช่น ราคาห้องพัก, จำนวนห้องว่าง (Inventory), ข้อมูลแขก, บัญชีรายรับรายจ่าย และสถานการณ์ชำระเงิน</p>
    <p><strong>2.2 การจัดการบัญชีผู้ใช้งาน:</strong> ผู้ใช้บริการต้องรักษาความลับของรหัสผ่านและรับผิดชอบต่อการกระทำใดๆ ที่เกิดขึ้นภายใต้บัญชีผู้ใช้งาน (User Account) ของซอฟท์แวร์ ทั้งนี้รวมไปถึง การกระทำการใดๆของพนักงานในโรงแรมแต่ละระดับที่มีสิทธิเข้าถึง (access) บัญชีผู้ใช้งานด้วย</p>
    <p><strong>2.3 การปฏิบัติตามกฎหมาย:</strong> ผู้ใช้บริการมีหน้าที่แต่เพียงผู้เดียวในการปฎิบัติให้เป็นไปตามกฎหมายในส่วนของการใช้ระบบ FROMAS และตกลงที่จะใช้ระบบ FROMAS เพื่อวัตถุประสงค์ที่ถูกต้องตามกฎหมายและสอดคล้องกับระเบียบข้อบังคับของธุรกิจโรงแรมในเขตพื้นที่ของท่าน</p>
    <p><strong>2.4 การป้องกันการทุจริตภายใน (Internal Fraud):</strong> ระบบ FROMAS มีการเก็บบันทึกประวัติการทำรายการ (Audit Trails) ผู้ใช้บริการมีหน้าที่ในการควบคุมดูแลและตรวจสอบความผิดปกติของการทำธุรกรรมในโรงแรมของท่านเอง ทางบริษัทจะไม่รับผิดชอบต่อความสูญเสียทางการเงิน หรือความเสียหายใดๆ ที่เกิดจากการทุจริต (Fraud) การยักยอกทรัพย์ การกระทำโดยจงใจหรือประมาทเลินเล่อของพนักงานของผู้ใช้บริการในทุกกรณี</p>
  </li>
  <li>
    <p><strong>ข้อตกลงพิเศษสำหรับการเชื่อมต่อระบบภายนอก (Third-Party Integrations &amp; OTA)</strong></p>
    <p><strong>3.1 กรณีระบบ Channel Manager และ OTA:</strong></p>
    <ul>
      <li>หากมีการเชื่อมต่อ OTA ผ่าน FROMAS (Channel Manager) บริษัททำหน้าที่เป็นเพียง "ตัวกลางในการส่งผ่านข้อมูล (Middleware)" เท่านั้น</li>
      <li>ผู้ใช้บริการมีหน้าที่รับผิดชอบในการตั้งค่าและตรวจสอบความถูกต้องของการจับคู่ห้องพัก (Room Mapping)</li>
      <li><strong>ปัญหา Overbooking:</strong> ในกรณีที่เกิดการรับจองซ้ำซ้อน ไม่ว่าจะเกิดจากความล่าช้าของเครือข่าย (Latency), การจองพร้อมกัน, หรือข้อขัดข้องทางเทคนิค FROMAS จะไม่รับผิดชอบต่อค่าใช้จ่ายในการย้ายที่พัก (Relocation Fee), ค่าปรับจาก OTA, หรือส่วนต่างราคาใดๆ โดยเด็ดขาด (ข้อพิพาทเป็นเรื่องระหว่างโรงแรมและ OTA โดยตรง)</li>
    </ul>
    <p><strong>3.2 กรณีการเชื่อมต่ออุปกรณ์และซอฟต์แวร์ภายนอกอื่นๆ:</strong><br/>หากผู้ใช้บริการมีการเชื่อมต่อ FROMAS เข้ากับระบบภายนอก เช่น ระบบคีย์การ์ด (Keycard), เครื่องสแกนหนังสือเดินทาง, เครื่องพิมพ์ใบกำกับภาษี, หรือระบบบัญชี (Accounting Software)</p>
    <ul>
      <li>FROMAS จะไม่รับผิดชอบหากเกิดการขัดข้อง อันเนื่องมาจากการที่ผู้ให้บริการภายนอกเหล่านั้นทำการเปลี่ยนแปลง API, อัปเดตเฟิร์มแวร์, หรือยุติการให้บริการ จนส่งผลให้ไม่สามารถทำงานร่วมกับ FROMAS ได้ตามปกติ</li>
    </ul>
  </li>
  <li>
    <p><strong>การจำกัดความรับผิดชอบสูงสุด (Limitation of Liability)</strong></p>
    <p><strong>4.1 การปฏิเสธความเสียหายต่อเนื่อง:</strong> ภายใต้ขอบเขตสูงสุดที่กฎหมายอนุญาต FROMAS จะไม่รับผิดชอบต่อความเสียหายทางอ้อม, ความเสียหายต่อเนื่อง (Consequential loss), การสูญเสียผลกำไร, การสูญเสียรายได้, การสูญเสียโอกาสทางธุรกิจ, หรือความเสียหายต่อชื่อเสียง ที่เกิดจากการใช้งานระบบ หรือการที่ระบบไม่สามารถใช้งานได้ ทั้งนี้ ความรับผิดสูงสุดของบริษัท พึงจำกัดเพียงค่าบริการรายปี/เดือน ของการให้บริการเท่านั้น</p>
    <p><strong>4.2 เพดานความรับผิดชอบ:</strong> หากมีเหตุให้ FROMAS ต้องรับผิดชอบต่อความเสียหายใดๆ ที่เกิดจากความผิดพลาดของระบบเราอย่างชัดเจน ความรับผิดชอบสูงสุดรวมทั้งหมดของ FROMAS จะถูกจำกัดเงื่อนไขตามรูปแบบการใช้งานดังนี้:</p>
    <ul>
      <li><strong>สำหรับระบบคลาวด์ (Cloud-based):</strong> มูลค่าสูงสุดไม่เกินจำนวนเงินค่าบริการที่ผู้ใช้บริการได้ชำระให้แก่ FROMAS ในรอบ 1 (หนึ่ง) เดือนที่ผ่านมา (หากผู้ใช้บริการชำระเป็นรายปี จะคำนวณโดยนำค่าบริการรายปีมาหารเฉลี่ยเป็นรายเดือน)</li>
      <li><strong>สำหรับระบบติดตั้งที่โรงแรม (On-Premise):</strong> มูลค่าสูงสุดไม่เกินค่าเฉลี่ย 1 (หนึ่ง) เดือน ของค่าบริการบำรุงรักษาระบบรายปี (MA - Maintenance Agreement) ที่ผู้ใช้บริการได้ชำระให้แก่บริษัทในปีที่เกิดเหตุ</li>
      <li>หรือ ชดเชยด้วยการขยายระยะเวลาการใช้งานระบบ หรือขยายระยะเวลาสัญญา MA ให้ฟรีในสัดส่วนที่เทียบเท่ากันเท่านั้น จะไม่มีการชดเชยเป็นเงินสดเกินกว่ามูลค่าที่ระบุไว้ข้างต้น</li>
    </ul>
  </li>
  <li>
    <p><strong>สิทธิในทรัพย์สินทางปัญญา (Intellectual Property Rights)</strong></p>
    <p><strong>5.1 ทรัพย์สินทางปัญญา FROMAS:</strong> FROMAS เป็นเจ้าของลิขสิทธิ์ ทรัพย์สินทางปัญญา ซอร์สโค้ด (Source Code) เครื่องหมายการค้า โลโก้ ไม่ว่าจะจดทะเบียนหรือไม่และสิทธิ์อื่นใดในอันเกี่ยวเนื่องกับซอฟต์แวร์ทั้งหมด เพื่อไม่เป็นการสงสัยการให้สิทธิ์ใช้งานระบบไม่อาจถือเป็นการโอนสิทธิทางทรัพย์สินทางปัญญา หรือสิทธิใดๆ ให้แก่ผู้ใช้บริการ ผู้ใช้บริการมีเพียงสิทธิในการใช้ภายใต้เงื่อนไขฉบับนี้และสัญญาฉบับอื่นใดที่ได้ลงนามไว้กับทางบริษัท ห้ามมิให้ผู้ใช้บริการคัดลอก ทำวิศวกรรมย้อนกลับ (Reverse Engineer) หรือดัดแปลงซอฟต์แวร์โดยเด็ดขาด</p>
    <p><strong>5.2 กรรมสิทธิ์ในข้อมูล (Customer Data):</strong> ข้อมูลของโรงแรม ข้อมูลแขก และข้อมูลธุรกรรมทั้งหมด ถือเป็นทรัพย์สินของผู้ใช้บริการ ทางบริษัท จะไม่นำข้อมูลเหล่านี้ไปใช้เพื่อผลประโยชน์อื่นนอกเหนือจากการให้บริการ</p>
  </li>
  <li>
    <p><strong>การชดเชยความเสียหายให้แก่ผู้ให้บริการ (Indemnification)</strong></p>
    <p>ผู้ใช้บริการตกลงจะปกป้อง คุ้มครอง ชดใช้ค่าเสียหาย และทำให้บริษัท บริษัทในเครือ และกรรมการ ผู้บริหาร พนักงาน ตัวแทน และบุคลากรที่เกี่ยวข้องของกับบริษัท พ้นจากและไม่ต้องรับผิดต่อข้อเรียกร้อง คำเรียกร้อง การฟ้องร้อง การดำเนินคดี ความเสียหาย ความรับผิด เบี้ยปรับ ค่าปรับ คำพิพากษา ต้นทุน และค่าใช้จ่ายใด ๆ ทั้งปวง (รวมถึงค่าทนายความและค่าดำเนินคดีตามสมควร) ที่เกิดขึ้นจาก หรือเกี่ยวเนื่องกับกรณีดังต่อไปนี้:<br/>(ก) การที่ผู้ใช้บริการฝ่าฝืนหรือไม่ปฏิบัติตามข้อกำหนดและเงื่อนไขฉบับนี้<br/>(ข) การที่ผู้ใช้บริการฝ่าฝืนกฎหมายที่ใช้บังคับ หรือกระทำการละเมิดสิทธิในทรัพย์สินทางปัญญา สิทธิในความเป็นส่วนตัว หรือสิทธิอื่นใดของบุคคลภายนอก (รวมถึงผู้เข้าพัก) และ<br/>(ค) ข้อพิพาท ข้อเรียกร้อง หรือข้อโต้แย้งใด ๆ ระหว่างผู้ใช้บริการกับแพลตฟอร์ม OTA หรือบุคคลภายนอกอื่นใด</p>
  </li>
  <li>
    <p><strong>การคุ้มครองข้อมูลส่วนบุคคล (Data Privacy &amp; PDPA)</strong></p>
    <p><strong>7.1</strong> ผู้ใช้บริการทำหน้าที่เป็น "ผู้ควบคุมข้อมูลส่วนบุคคล" (Data Controller) และ FROMAS ทำหน้าที่เป็น "ผู้ประมวลผลข้อมูลส่วนบุคคล" (Data Processor)</p>
    <p><strong>7.2</strong> ผู้ใช้บริการยืนยันว่าได้รับข้อมูลของแขกมาโดยชอบด้วยกฎหมายคุ้มครองข้อมูลส่วนบุคคล (PDPA) FROMAS จะจัดเก็บและประมวลผลข้อมูลตามคำสั่งของผู้ใช้บริการ และใช้มาตรการรักษาความปลอดภัยทางไซเบอร์ตามมาตรฐานอุตสาหกรรม</p>
  </li>
  <li>
    <p><strong>การระงับและการยกเลิกบริการ (Suspension and Termination)</strong></p>
    <p><strong>8.1 การค้างชำระ:</strong> หากผู้ใช้บริการค้างชำระค่าบริการ (รวมถึงค่าบริการรายเดือน หรือ ค่า MA รายปี) เกินกว่าระยะเวลาที่กำหนด FROMAS ขอสงวนสิทธิ์ในการระงับการเข้าถึงระบบและการให้บริการสนับสนุนชั่วคราวจนกว่าจะมีการชำระเงินครบถ้วน</p>
    <p><strong>8.2 ผลของการยกเลิก:</strong> เมื่อสิ้นสุดสัญญาหรือยกเลิกบริการ (ไม่ว่าจะด้วยเหตุใด) สิทธิในการเข้าถึงระบบของผู้ใช้บริการจะสิ้นสุดลงทันที สำหรับระบบ Cloud ผู้ใช้บริการมีหน้าที่ร้องขอการดึงข้อมูล (Export Data) ภายใน 30 วันหลังสิ้นสุดบริการ หลังจากนั้น FROMAS ขอสงวนสิทธิ์ในการลบข้อมูลออกจากระบบอย่างถาวร</p>
  </li>
  <li>
    <p><strong>ข้อกำหนดทั่วไป (General Provisions)</strong></p>
    <p><strong>9.1 เหตุสุดวิสัย (Force Majeure):</strong> FROMAS จะไม่รับผิดชอบต่อความล่าช้าหรือการไม่สามารถให้บริการได้ หากเกิดจากเหตุการณ์ที่อยู่นอกเหนือการควบคุม เช่น ภัยธรรมชาติ, สงคราม, การก่อการร้าย, นัดหยุดงาน, ปัญหาเครือข่ายโทรคมนาคมล่มระดับประเทศ, เซิร์ฟเวอร์คลาวด์ของผู้ให้บริการหลักขัดข้อง, ตลอดจนการตกเป็นเป้าหมายของการโจมตีทางไซเบอร์ขั้นรุนแรง (Severe Cyberattacks / Ransomware)</p>
    <p><strong>9.2 กฎหมายที่ใช้บังคับ (Governing Law):</strong> ข้อตกลงนี้ให้อยู่ภายใต้บังคับและการตีความตามกฎหมายแห่งราชอาณาจักรไทย</p>
    <p><strong>9.3 การแยกส่วนของสัญญา (Severability):</strong> หากข้อกำหนดใดในข้อตกลงนี้ตกเป็นโมฆะหรือไม่สามารถบังคับใช้ได้ ให้ข้อกำหนดส่วนที่เหลือยังคงมีผลสมบูรณ์และบังคับใช้ได้ต่อไป</p>
  </li>
</ol>
</div>`,

  en: `<div>
<h3 style="margin-top:0">Notice of Terms &amp; Conditions Update</h3>
<p><strong>Last Updated: [10 April 2026]</strong></p>
<p>Dear FROMAS System Users,</p>
<p>To enhance our service quality and align with current software management standards, Newsoft Technology Consultants Co., Ltd., the administrator of the FROMAS system ("Service Provider", "we", "Company"), has updated the Terms &amp; Conditions of Service. This agreement is legally binding between us and you/the hotel ("User", "Customer").</p>
<p>By clicking Accept, or continuing to use the FROMAS system, you acknowledge that you have read, understood, and agreed to all the terms and conditions stated below.</p>
<ol>
  <li>
    <p><strong>Scope and Delivery of Service</strong></p>
    <p>FROMAS provides Hotel Property Management System (PMS) software and additional services such as Channel Management System. The software is provided "AS IS" and covers 2 installation types:</p>
    <p><strong>1.1 Cloud-based / SaaS:</strong><br/>We provide the system through our managed cloud servers. Users are responsible for providing stable equipment and internet connectivity. We are responsible for maintenance, system updates, and backup according to our standards.</p>
    <p><strong>1.2 On-Premise:</strong><br/>The system is installed on the user's own hardware or server. Users are fully responsible for managing internal network infrastructure, server operational conditions, virus/malware protection, and backup configuration.</p>
    <p><strong>a. Malware Damage (Ransomware/Malware):</strong> If your server is subject to cyber attacks, viruses, ransomware, or hardware failure resulting in data loss or system downtime, FROMAS bears no responsibility whatsoever.</p>
    <p><strong>b. Service Fees Outside MA Contract:</strong> If users request FROMAS team to perform data recovery, database repair, or system reinstallation due to such incidents, additional Technical Service Charges will apply, outside the scope of the Annual Maintenance Agreement (MA).</p>
  </li>
  <li>
    <p><strong>PMS Usage and Customer Responsibilities</strong></p>
    <p><strong>2.1 Data Accuracy:</strong> Users are solely responsible for the accuracy of all data entered into the system, such as room rates, inventory, guest information, accounts, and payment status.</p>
    <p><strong>2.2 User Account Management:</strong> Users must keep passwords confidential and be responsible for all actions under user accounts at each employee level.</p>
    <p><strong>2.3 Legal Compliance:</strong> Users agree to use the FROMAS system for lawful purposes, in accordance with hotel business regulations in their jurisdiction.</p>
    <p><strong>2.4 Internal Fraud Prevention:</strong> FROMAS maintains Audit Trails. Users are responsible for monitoring and detecting transaction anomalies in their hotel. FROMAS bears no responsibility for financial losses or damages resulting from fraud, embezzlement, or negligence of users' employees in all cases.</p>
  </li>
  <li>
    <p><strong>Special Terms for Third-Party Integrations &amp; OTA</strong></p>
    <p><strong>3.1 Channel Manager and OTA:</strong><br/>If OTA integration is made through FROMAS (Channel Manager), we act only as a "Middleware" for data transmission. Users are responsible for configuring and verifying room mapping accuracy.</p>
    <p><strong>Overbooking Issues:</strong> In cases of double bookings due to network latency, simultaneous reservations, or technical issues, FROMAS bears absolutely no responsibility for relocation fees, OTA penalties, or any price differences (disputes are directly between the hotel and OTA).</p>
    <p><strong>3.2 Other External Device and Software Integrations:</strong><br/>If users integrate FROMAS with external systems such as keycard systems, passport scanners, tax invoice printers, or accounting software, FROMAS bears no responsibility for failures caused by third-party providers changing APIs, updating firmware, or discontinuing services.</p>
  </li>
  <li>
    <p><strong>Limitation of Liability</strong></p>
    <p><strong>4.1 Consequential Damages Disclaimer:</strong> To the maximum extent permitted by law, FROMAS shall not be liable for indirect damages, consequential loss, loss of profits, loss of revenue, loss of business opportunity, or reputational damage.</p>
    <p><strong>4.2 Liability Cap:</strong> Maximum aggregate liability is limited based on usage type:</p>
    <ul>
      <li><strong>Cloud-based:</strong> Not exceeding the service fees paid to FROMAS in the preceding 1 (one) month.</li>
      <li><strong>On-Premise:</strong> Not exceeding the average of 1 (one) month of the Annual Maintenance Agreement (MA) fee paid in the year of the incident.</li>
    </ul>
  </li>
  <li>
    <p><strong>Intellectual Property Rights</strong></p>
    <p><strong>5.1 FROMAS Ownership:</strong> FROMAS owns all copyrights, intellectual property, source code, logos, and software rights. Users are strictly prohibited from copying, reverse engineering, or modifying the software.</p>
    <p><strong>5.2 Customer Data Ownership:</strong> Hotel data, guest data, and all transaction data are the property of users. FROMAS will not use this data for any purposes other than providing the service.</p>
  </li>
  <li>
    <p><strong>Indemnification</strong></p>
    <p>Users agree to defend, indemnify, and hold harmless FROMAS, its employees, and management from any claims, lawsuits, fines, or expenses arising from: (a) Users violating these Terms &amp; Conditions; (b) Users violating laws, intellectual property, or third-party rights; (c) Disputes between users and OTA platforms or other third parties.</p>
  </li>
  <li>
    <p><strong>Data Privacy &amp; PDPA</strong></p>
    <p><strong>7.1</strong> Users act as "Data Controller" and FROMAS acts as "Data Processor".</p>
    <p><strong>7.2</strong> Users confirm that guest data has been obtained in compliance with the Personal Data Protection Act (PDPA). FROMAS will store and process data according to user instructions using industry-standard cybersecurity measures.</p>
  </li>
  <li>
    <p><strong>Suspension and Termination</strong></p>
    <p><strong>8.1 Overdue Payments:</strong> If users have overdue service fees beyond the specified period, FROMAS reserves the right to temporarily suspend system access and support services until full payment is received.</p>
    <p><strong>8.2 Effect of Termination:</strong> Upon contract termination or service cancellation, users' system access rights terminate immediately. For Cloud systems, users must request data export within 30 days after service termination.</p>
  </li>
  <li>
    <p><strong>General Provisions</strong></p>
    <p><strong>9.1 Force Majeure:</strong> FROMAS shall not be liable for delays or inability to provide services due to events beyond our control, such as natural disasters, war, terrorism, strikes, national network failures, cloud provider outages, or severe cyberattacks.</p>
    <p><strong>9.2 Governing Law:</strong> This agreement shall be governed by and interpreted under the laws of the Kingdom of Thailand.</p>
    <p><strong>9.3 Severability:</strong> If any provision of this agreement is void or unenforceable, the remaining provisions shall remain in full force and effect.</p>
  </li>
</ol>
</div>`,

  ch: `<div>
<h3 style="margin-top:0">服务条款与条件更新通知</h3>
<p><strong>最后更新时间：[10 四月 2026]</strong></p>
<p>尊敬的 FROMAS 系统用户，</p>
<p>为提升服务质量并符合当前软件管理标准，FROMAS 系统管理方纽索夫特技术顾问有限公司（"服务提供商"、"我们"、"公司"）已更新服务条款与条件。本协议在我们与您/酒店（"用户"、"客户"）之间具有法律约束力。</p>
<p>点击接受，或继续使用 FROMAS 系统，即表示您已阅读、理解并同意以下所有条款和条件。</p>
<ol>
  <li>
    <p><strong>服务范围与交付方式</strong></p>
    <p>FROMAS 提供酒店物业管理系统（PMS）软件及附加服务（如渠道管理系统）。软件以"现状"（AS IS）方式提供，涵盖以下 2 种安装类型：</p>
    <p><strong>1.1 云端服务 (Cloud-based / SaaS)：</strong><br/>我们通过托管云服务器提供系统。用户负责提供稳定的设备和网络连接。我们负责维护、更新和数据备份。</p>
    <p><strong>1.2 本地部署 (On-Premise)：</strong><br/>系统安装在用户自己的硬件或服务器上。用户全权负责内部网络管理、服务器运行状况、防病毒防护及备份配置。</p>
    <p><strong>甲. 恶意软件损害：</strong>若您的服务器遭受网络攻击、病毒、勒索软件或硬件故障，导致数据丢失或系统停机，FROMAS 不承担任何责任。</p>
    <p><strong>乙. 维护协议范围外的服务费：</strong>若用户要求 FROMAS 执行数据恢复、数据库修复或系统重装，将收取额外技术服务费，此费用超出年度维护协议（MA）范围。</p>
  </li>
  <li>
    <p><strong>PMS 使用及客户责任</strong></p>
    <p><strong>2.1 数据准确性：</strong>用户对输入系统的所有数据准确性负全责，包括房价、库存、宾客信息、账目及付款状态。</p>
    <p><strong>2.2 用户账户管理：</strong>用户须保守密码机密，并对各级员工账户下发生的所有操作负责。</p>
    <p><strong>2.3 法律合规：</strong>用户同意合法使用 FROMAS 系统，并遵守所在司法管辖区的酒店业务法规。</p>
    <p><strong>2.4 内部欺诈防范：</strong>FROMAS 维护审计追踪记录。用户负责监控酒店内的异常交易。FROMAS 对因员工欺诈、挪用公款或疏忽造成的损失不承担任何责任。</p>
  </li>
  <li>
    <p><strong>第三方集成及 OTA 特别条款</strong></p>
    <p><strong>3.1 渠道管理器及 OTA：</strong><br/>通过 FROMAS（渠道管理器）进行 OTA 集成时，我们仅作为数据传输"中间件"。用户负责配置和验证房型映射准确性。</p>
    <p><strong>超额预订问题：</strong>因网络延迟、同时预订或技术问题导致重复预订时，FROMAS 对搬迁费、OTA 罚款或任何价差不承担责任。</p>
    <p><strong>3.2 其他外部设备及软件集成：</strong><br/>因第三方提供商更改 API、更新固件或停止服务导致无法与 FROMAS 正常集成，FROMAS 不承担责任。</p>
  </li>
  <li>
    <p><strong>责任限制</strong></p>
    <p><strong>4.1 间接损害免责声明：</strong>在法律允许的最大范围内，FROMAS 不对间接损害、衍生损失、利润损失、收入损失或声誉损害承担责任。</p>
    <p><strong>4.2 责任上限：</strong></p>
    <ul>
      <li><strong>云端服务：</strong>不超过用户前 1 个月向 FROMAS 支付的服务费。</li>
      <li><strong>本地部署：</strong>不超过事故发生年度年度维护协议（MA）费用的月均值。</li>
    </ul>
  </li>
  <li>
    <p><strong>知识产权</strong></p>
    <p><strong>5.1 FROMAS 所有权：</strong>FROMAS 拥有所有版权、知识产权、源代码、商标及软件权利。严禁复制、逆向工程或修改软件。</p>
    <p><strong>5.2 客户数据所有权：</strong>酒店数据、宾客数据及所有交易数据归用户所有。FROMAS 不将数据用于提供服务以外的目的。</p>
  </li>
  <li>
    <p><strong>赔偿</strong></p>
    <p>用户同意为 FROMAS 及其员工辩护、赔偿并使其免受因以下原因引起的索赔：（甲）违反本条款；（乙）侵犯法律、知识产权或第三方权利；（丙）与 OTA 或其他第三方之间的争议。</p>
  </li>
  <li>
    <p><strong>数据隐私及 PDPA</strong></p>
    <p><strong>7.1</strong> 用户担任"数据控制者"，FROMAS 担任"数据处理者"。</p>
    <p><strong>7.2</strong> 用户确认已依据个人数据保护法（PDPA）合法获取宾客数据。FROMAS 将按用户指示处理数据，并采用行业标准安全措施。</p>
  </li>
  <li>
    <p><strong>暂停与终止服务</strong></p>
    <p><strong>8.1 逾期付款：</strong>若用户逾期支付服务费，FROMAS 保留暂停系统访问和支持服务的权利，直至全额付款。</p>
    <p><strong>8.2 终止效力：</strong>服务终止后，用户访问权立即终止。云端系统用户须在 30 天内申请数据导出，否则 FROMAS 保留永久删除数据的权利。</p>
  </li>
  <li>
    <p><strong>一般条款</strong></p>
    <p><strong>9.1 不可抗力：</strong>因自然灾害、战争、恐怖主义、罢工、全国网络故障、云服务故障或严重网络攻击导致无法提供服务，FROMAS 不承担责任。</p>
    <p><strong>9.2 适用法律：</strong>本协议受泰王国法律管辖。</p>
    <p><strong>9.3 可分割性：</strong>若任何条款无效，其余条款仍完全有效。</p>
  </li>
</ol>
</div>`,
};

export const POLICY_CONTENT: Record<PolicyLang, string> = {
  en: `<div>
    <h2>Privacy Policy</h2>
    <ol>

        <li>
            <p><strong>Our Privacy Statement</strong></p>
            <p>Newsoft Technologies Consultants (the "Company" or "we") has established and disclose this Privacy
                approach to explain how we process personal data of our customers, vendors, and other business partners
                including its corporate entity's individuals such as its employees, contact persons, and directors since
                the protection of your personal data is of great importance to us.
            </p>
            <p>We process your personal data in accordance with the applicable regulation relating to personal data
                protection, in particular the Personal Data Protection Act B.E. 2562 ("PDPA"). This Privacy Policy
                explains how we, as the data controller, collect, use and disclose your personal data. In addition, we
                regularly review and update this Privacy Policy and in case of any significant update to this Privacy
                Policy, we will inform you as appropriate.
            </p>
        </li>

        <li>
            <p><strong>Personal Data to be Collected</strong></p>
            <p>Regarding the PDPA, personal data means any information relating to an individual, which enables the
                identification of such individual, whether directly or indirectly, but not including the information of
                the deceased persons in particular.
            </p>
            <p>We collect the following personal data for processing to achieve the purposes as herein with the legal
            basis provided for in the PDPA. In addition, we may process your personal data of a sensitive nature,
            including your religious beliefs and health information, in accordance with special criteria provided for in
            the PDPA. We collect your personal data directly from you or your personal data may be collected from the
            recruitment agency company.
            </p>
            <ul>
                <li><strong>General Personal Data</strong>
                    <p>Name, Surname, Phone number, Email, data regarding the use of application and device information.
                    </p>
                </li>
            </ul>
        </li>

        <li>
            <p><strong>Purpose of Processing of Personal Data</strong></p>
            <p>The Company collect, use, or disclose your Personal Data for various purposes depending on relationship
                between you and the Company as follows:
            <p>
            <ul>
                <li>
                    <p>To provide general use of our products and services to you including any other services in relation to our products and services, for example, sending email, printing report, etc.
                    </p>
                </li>
                <li>
                    <p>To analyze the usage of our products and services for purposes of determining usage made of our products and services, for purposes of security, to assist customers, and for improving the products, the services and user experience in using such products and services.
                    </p>
                </li>
            </ul>
        </li>

        <li>
            <p><strong>Legal Basis for Processing of Personal Data</strong></p>
            <p>The legal basis for the processing of your personal data is as follows:
            </p>
            <ul>
                <li>
                    <p>When required by the law, a consent shall be obtained;</p>
                </li>
                <li>
                    <p>When the processing activity is necessary for the performance of contractual obligations to
                        perform contractual obligations between you and the Company;
                    </p>
                </li>
                <li>
                    <p>When the processing activity is required for the pursuit of legitimate interests of the Company;
                    </p>
                </li>
                <li>
                    <p>When the processing activity is required for the compliance with our legal obligations.</p>
                </li>
            </ul>

            <p>You have the right to withdraw your consent at any time by the method separately designated by us at the timing of obtaining your consent. However, your withdrawal of consent will not affect the legality of processing conducted based on your consent before its withdrawal.</p>
            <p>We will notify you separately, if the provision of personal data is a statutory or contractual requirement, or a requirement necessary to enter into a contract, as well as the possible consequences of failure to provide such data.</p>
        </li>

        <li>
            <p><strong>Retention Period for Personal Data </strong></p>
            <p>We will retain your personal data for as long as necessary to fulfill the aforementioned purposes for
                obtaining and processing your personal data. Specific criteria used to determine our retention periods
                are the duration we have an ongoing relationship with you, the compliance with applicable laws, the
                compliance with legal prescription to exercise the rights to legal claims or defend against the rights
                to legal claims and the necessity of retaining the personal data for other legal or business reasons.
            </p>
            <p>Please kindly be ensured that the retention of personal data after the expiry date of retention period
                will only occur only in the necessary circumstance. When the retention period has ended or the retention
                of such data is no longer necessary (whichever is applicable), we will destroy or erase such data from
                our system.</p>
        </li>

        <li>
            <p><strong>Disclosure of Personal Data</strong></p>
            <p>We may share and disclose your personal data to the following third parties in accordance with the PDPA
                for the purposes stated in this privacy policy. The Company will inform you to acknowledge and request
                for consent as necessary and required by the PDPA.
            </p>
            <ul>
                <li>
                    <p>Subsidiaries, affiliates and any related companies for business purposes</p>
                </li>
                <li>
                    <p>Government authorities, or other authorities as stipulated by laws, including competent
                        officials, e.g., courts, police officers, the Revenue Department, the Social Security Office,
                        the Department of Labour Protection and Welfare, etc.</p>
                </li>
                <li>
                    <p>Agencies, service providers and/or sub-contractors for their implementation and procedures, for
                        example, accounting company, tax consultants and work permit agency company</p>
                </li>
            </ul>
            <p>As a result of the aforementioned sharing and disclosure, in some cases your personal data will be
                transferred to the recipient company in Japan with an appropriate safeguards by executing with the
                transferee the standard data protection causes including Binding Corporate Rules or Data Processing
                Agreement (if any or whichever is appropriate) pursuant to the PDPA, unless the data transferred country
                has appropriate data protection standard as prescribed by the Personal Data Protection Committee or we
                obtain your consent pursuant to the PDPA. If you wish to receive a copy of documentation related to
                these safeguards, please inquire using the contact details at the end of this privacy policy.
            </p>
        </li>

        <li>
            <p><strong>Your Rights as a Data Subject</strong></p>
            <p>You have the following rights regarding personal data obtained and processed by us.
            </p>
            <ul>
                <li>
                    <p><u>Obtaining information regarding processing of data:</u> You have the right to obtain from us
                        all the requisite information regarding our data processing activities that concern you.</p>
                </li>
                <li>
                    <p><u>Access to personal data:</u> You have the right to obtain from us confirmation as to whether
                        personal data concerning you are being processed, and, if so, then access to the personal data
                        and certain related information. </p>
                </li>
                <li>
                    <p><u>Rectification or erasure of personal data:</u> You have the right to have us rectify
                        inaccurate personal data concerning you without undue delay and the right to have us complete
                        any incomplete personal data. Also, if certain conditions are satisfied, you will have the right
                        to have us delete personal data concerning you without undue delay.</p>
                </li>
                <li>
                    <p><u>Restriction on processing of personal data:</u> If certain conditions are satisfied, you will
                        have the right to have us restrict processing of personal data concerning you.</p>
                </li>
                <li>
                    <p><u>Objection to processing of personal data:</u> If certain conditions are satisfied, you will
                        have the right to object to processing of personal data concerning you.</p>
                </li>
                <li>
                    <p><u>Data portability of personal data:</u> - Data portability of personal data: </p>
                </li>
                <li>
                    <p><u>To be subject to automated decision-making:</u> If certain conditions are satisfied, you will
                        have the right not to be subject to solely data-based, automated decision-making (including
                        profiling) that produces any legal or similar material effect on you.</p>
                </li>
            </ul>
            <p>If you intend to exercise any of the aforementioned rights, please inquire using the contact details at
                the end of this privacy policy.</p>
        </li>

        <li>
            <p><strong>Data Protection Security Measures</strong></p>
            <p>The Company implements appropriate and strict security measures for preventing unauthorized or unlawful
                loss, access to, use, alteration, correction or disclosure of personal information.
            </p>
            <p>In case where the Company assigns any third party to process your personal information pursuant to the
                instructions given by or on behalf of the Company, the Company shall appropriately supervise such third
                party to ensure your personal information protection in accordance with the PDPA.</p>
        </li>

        <li>
            <p><strong>Contact details</strong></p>
            <p><strong>E-mail:</strong> <a href="mailto:dpo@newsoft.co.th">dpo@newsoft.co.th</a>
            </p>
            <p><strong>Address:</strong> 61/277 Rama 9 Road, Huay-Kwang, Bangkok 10310
            </p>
            <p><strong>Telephone:</strong> 0-2246-1122-4
            </p>
            <p><strong>Website:</strong> <a href="https://newsoft.co.th/" target="_blank">www.newsoft.co.th</a></p>
            <p>This Policy applies to the use of our software only. When you link to third party software via our
                software, the personal information protection shall be in accordance with the Privacy Policy of such
                software which are not related to the Company.
            </p>
        </li>

    </ol>
    </div>`,

  th: `<div>
    <h2>นโยบายความเป็นส่วนตัว</h2>
    <ol>

        <li>
            <p><strong>คำรับรอง</strong></p>
            <p>นิวซอฟท์เทคโนโลยี คอนซัลเทนท์ ("บริษัท")  มีความตระหนักถึงความสำคัญของการคุ้มครองข้อมูลส่วนบุคคลเป็นอย่างยิ่ง จึงได้จัดทำและเผยแพร่นโยบายความเป็นส่วนตัวฉบับนี้ ("นโยบาย") เพื่อชี้แจงรายละเอียดเกี่ยวกับการเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคลของลูกค้าและคู่ค้าบุคคลธรรมดา รวมถึงกรรมการ ผู้แทน ผู้รับมอบอำนาจ หรือผู้ปฏิบัติงานในนามของลูกค้าและคู่ค้านิติบุคคล รวมถึงวิธีการในการปกป้องคุ้มครองข้อมูลส่วนบุคคลและแนวทางการจัดการข้อมูลดังกล่าวอย่างเหมาะสม
            </p>
            <p>บริษัทประมวลผลข้อมูลส่วนบุคคลอย่างสอดคล้องกับกฎหมายคุ้มครองข้อมูลส่วนบุคคล โดยเฉพาะพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562 ("กฎหมายคุ้มครองข้อมูลส่วนบุคคล") บริษัทมีการพิจารณาทบทวนและอาจแก้ไขเปลี่ยนแปลงนโยบายนี้ตามความเหมาะสมอยู่เป็นระยะเพื่อให้แน่ใจว่าข้อมูลส่วนบุคคลของท่านจะได้รับความคุ้มครองอย่างเหมาะสม หากนโยบายนี้มีการแก้ไขเปลี่ยนแปลงอย่างมีนัยสำคัญ บริษัทจะแจ้งให้ท่านทราบด้วยการเผยแพร่ผ่านช่องทางที่เหมาะสม
            </p>
        </li>

        <li>
            <p><strong>ข้อมูลส่วนบุคคลที่บริษัทเก็บรวบรวม</strong></p>
            <p>อ้างอิงนิยามตามกฎหมายคุ้มครองข้อมูลส่วนบุคคล ข้อมูลส่วนบุคคล หมายถึง ข้อมูลเกี่ยวกับบุคคลธรรมดาซึ่งทำให้สามารถระบุตัวบุคคลนั้นได้ไม่ว่าทางตรงหรือทางอ้อม แต่ไม่รวมถึงข้อมูลผู้ถึงแก่กรรมโดยเฉพาะ
            </p>
            <p>บริษัทมีการเก็บรวบรวมข้อมูลส่วนบุคคลของท่านดังต่อไปนี้ เพื่อบรรลุวัตถุประสงค์ตามที่ระบุ พร้อมทั้งฐานทางกฎหมายในการประมวลผลข้อมูลส่วนบุคคลตามที่กฎหมายคุ้มครองข้อมูลส่วนบุคคลกำหนด บริษัทอาจมีการประมวลผลข้อมูลส่วนบุคคลประเภทอ่อนไหวโดยปฏิบัติตามข้อกำหนดของกฎหมายคุ้มครองข้อมูลส่วนบุคคลอย่างเคร่งครัด
            </p>
            <p>ทั้งนี้ บริษัทมีการเก็บรวบรวมข้อมูลส่วนบุคคลของท่านโดยตรง หรืออาจมีการเก็บข้อมูลส่วนบุคคลของท่านจากแหล่งอื่น เช่น บริษัทที่ท่านเป็นกรรมการ ผู้แทน ผู้รับมอบอำนาจ หรือผู้ปฏิบัติงาน เป็นต้น
            </p>

            <ul>
                <li><strong>ข้อมูลส่วนบุคคลประเภททั่วไป</strong>
                    <p>ชื่อ นามสกุล หมายเลขโทรศัพท์ อีเมล ข้อมูลการใช้งานซอฟท์แวร์ของบริษัท และอุปกรณ์ที่เข้าใช้งาน
                    </p>
                </li>
            </ul>
        </li>

        <li>
            <p><strong>วัตถุประสงค์ในการประมวลผลข้อมูลส่วนบุคคล</strong></p>
            <p>บริษัทดำเนินการเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลของท่านเพื่อวัตถุประสงค์หลายประการโดยขึ้นอยู่กับลักษณะความสัมพันธ์ระหว่างท่านกับบริษัท ดังต่อไปนี้
            </p>
            <ul>
                <li>
                    <p>เพื่อการใช้งานขั้นพื้นฐานของผลิตภัณฑ์หรือบริการต่างๆ ของบริษัท รวมถึงการใช้งานอื่นๆ ที่เกี่ยวข้องกับการใช้ผลิตภัณฑ์หรือบริการดังกล่าว เช่น การส่งอีเมล การออกรายงาน ฯลฯ
                    </p>
                </li>
                <li>
                    <p>เพื่อวิเคราะห์ข้อมูลการใช้งานผลิตภัณฑ์และบริการของท่าน ทั้งในแง่ของจุดประสงค์และเป้าหมายในการใช้งาน ในแง่ของการรักษาความปลอดภัย ในแง่การช่วยเหลือและส่งเสริมการใช้งาน และนำมาพัฒนาผลิตภัณฑ์และบริการต่าง ๆ ของบริษัท ให้ตรงตามความต้องการของท่านได้ดียิ่งขึ้น
                    </p>
                </li>
            </ul>
        </li>

        <li>
            <p><strong>ฐานกฎหมายในการประมวลผลข้อมูลส่วนบุคคล</strong></p>
            <p>บริษัทจะประมวลผลข้อมูลส่วนบุคคลเท่าที่จำเป็นภายใต้ขอบเขตของนโยบายความเป็นส่วนตัวฉบับนี้ ในกรณีต่อไปนี้
            </p>
            <ul>
                <li>
                    <p>เมื่อบริษัทได้รับความยินยอมจากท่าน สำหรับกรณีที่กฎหมายกำหนดให้ต้องขอความยินยอม</p>
                </li>
                <li>
                    <p>เพื่อดำเนินการตามคำขอของท่านก่อนเข้าทำสัญญาหรือเพื่อการปฏิบัติตามสัญญาระหว่างท่านและบริษัท</p>
                </li>
                <li>
                    <p>เป็นการจำเป็นเพื่อประโยชน์โดยชอบด้วยกฎหมายของบริษัทหรือของบุคคลหรือนิติบุคคลอื่น เว้นแต่ประโยชน์ดังกล่าวมีความสำคัญน้อยกว่าสิทธิขั้นพื้นฐานในข้อมูลส่วนบุคคลของท่าน
                    </p>
                </li>
                <li>
                    <p>เป็นการปฏิบัติตามกฎหมายของบริษัท</p>
                </li>
            </ul>
            <p>ในกรณีที่บริษัทประมวลผลข้อมูลส่วนบุคคลของท่านโดยอ้างอิงความยินยอมเป็นฐานทางกฎหมาย ท่านมีสิทธิในการถอนความยินยอมของท่านได้ทุกเมื่อผ่านช่องทางที่บริษัทกำหนด ทั้งนี้ การถอนความยินยอมของท่านไม่กระทบต่อการประมวลผลข้อมูลส่วนบุคคลที่ได้เกิดขึ้นแล้วก่อนการถอนความยินยอมโดยอ้างอิงความยินยอมโดยชอบด้วยกฎหมาย
            </p>
            <p>บริษัทจะแจ้งให้ท่านทราบต่างหาก ในกรณีที่ข้อมูลส่วนบุคคลที่บริษัทเก็บรวบรวมข้างต้นเป็นข้อมูลที่จำเป็นต่อบริษัทในการปฏิบัติตามกฎหมายต่าง ๆ ที่ใช้บังคับหรือการปฏิบัติตามสัญญา รวมถึง ผลกระทบหากท่านไม่ให้ข้อมูลส่วนบุคคลที่จำเป็นดังกล่าว
            </p>
        </li>

        <li>
            <p><strong>ระยะเวลาในการเก็บรักษาข้อมูลส่วนบุคคล</strong></p>
            <p>บริษัทจะเก็บรักษาข้อมูลส่วนบุคคลของท่านเป็นระยะเวลาเท่าที่จำเป็นเพื่อวัตถุประสงค์ในการเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคลซึ่งได้ระบุไว้ในนโยบายความเป็นส่วนตัวนี้ หลักเกณฑ์ที่ใช้กำหนดระยะเวลาเก็บ ได้แก่ ระยะเวลาที่บริษัทดำเนินความสัมพันธ์กับท่าน และอาจเก็บต่อไปตามระยะเวลาที่จำเป็นเพื่อการปฏิบัติตามกฎหมายหรือตามอายุความทางกฎหมาย เพื่อการก่อตั้งสิทธิเรียกร้องตามกฎหมาย การปฏิบัติตามหรือการใช้สิทธิเรียกร้องตามกฎหมาย หรือการยกขึ้นต่อสู้สิทธิเรียกร้องตามกฎหมาย หรือเพื่อเหตุอื่นตามนโยบายและข้อกำหนดภายในองค์กรของบริษัท
            </p>
            <p>บริษัทอาจมีความจำเป็นในการเก็บรักษาข้อมูลส่วนบุคคลของท่านหลังจากระยะเวลาในการเก็บรักษาข้อมูลส่วนบุคคลที่กำหนด อย่างไรก็ตาม เมื่อข้อมูลส่วนบุคคลของท่านหมดความจำเป็นต่อการประมวลผลข้อมูลส่วนบุคคลของบริษัท บริษัทจะทำลายหรือลบข้อมูลส่วนบุคคลของท่านออกจากระบบทันที</p>
        </li>

        <li>
            <p><strong>การเปิดเผยข้อมูลส่วนบุคคล</strong></p>
            <p>ในการประมวลผลข้อมูลส่วนบุคคลตามวัตถุประสงค์ที่ระบุไว้ในนโยบายนี้ บริษัทอาจเปิดเผยข้อมูลส่วนบุคคลของท่านให้แก่บุคคลภายนอก ดังต่อไปนี้ ทั้งนี้ กรณีที่มีการเปิดเผยข้อมูลส่วนบุคคลบริษัทจะปฏิบัติตามกฎหมายคุ้มครองข้อมูลส่วนบุคคลอย่างเคร่งครัด รวมทั้งจะแจ้งให้ท่านทราบ และขอความยินยอมจากท่านในกรณีที่กฎหมายคุ้มครองข้อมูลส่วนบุคคลกำหนด
            </p>
            <ul>
                <li>
                    <p>บริษัทย่อย บริษัทในกลุ่ม และบริษัทในเครือ เพื่อวัตถุประสงค์ในการดำเนินธุรกิจ การบริหารงานภายใน</p>
                </li>
                <li>
                    <p>หน่วยงานราชการ หน่วยงานกำกับดูแล หรือหน่วยงานอื่นตามที่กฎหมายกำหนด รวมถึงเจ้าพนักงานซึ่งใช้อำนาจตามกฎหมาย เช่น กรมสรรพากร เป็นต้น</p>
                </li>
                <li>
                    <p>ตัวแทน ผู้รับจ้าง/ผู้รับจ้างช่วง และ/หรือผู้ให้บริการสำหรับการดำเนินงานใด ๆ เช่น ผู้ให้บริการขนส่ง ผู้ให้บริการด้านการชำระเงินและระบบชำระเงิน ผู้ตรวจสอบบัญชี ทนายความ ที่ปรึกษากฎหมายและภาษี ที่ปรึกษาใด ๆ</p>
                </li>
            </ul>
            <p>ในกรณีที่บริษัทมีการเปิดเผยข้อมูลส่วนบุคคลข้างต้นไปต่างประเทศ บริษัทจะจัดให้มีมาตรการการคุ้มครองและรักษาความปลอดภัยที่เหมาะสม เช่น การทำสัญญาแบ่งปันข้อมูลส่วนบุคคล สัญญาประมวลผลข้อมูลส่วนบุคคล หรือข้อตกลงระหว่างบริษัทย่อย บริษัทในกลุ่ม และบริษัทในเครือ และจะปฏิบัติตามกฎหมายคุ้มครองข้อมูลส่วนบุคคล เว้นแต่ ประเทศผู้รับข้อมูลส่วนบุคคลมีมาตรการการคุ้มครองและรักษาความปลอดภัยที่เหมาะสมตามกฎหมายคุ้มครองข้อมูลส่วนบุคคลกำหนด หรือ บริษัทได้ขอความยินยอมโดยชอบด้วยกฎหมายจากท่านก่อนการเปิดเผยข้อมูลส่วนบุคคล หากท่านมีความประสงค์ในการรับทราบรายละเอียดมาตรการการคุ้มครองและรักษาความปลอดภัยของบริษัท ท่านสามารถติดต่อขอรับรายละเอียดได้ที่ช่องทางการติดต่อที่ระบุในนโยบายนี้
            </p>
        </li>

        <li>
            <p><strong>สิทธิของท่านในฐานะเจ้าของข้อมูลส่วนบุคคล</strong></p>
            <p>ท่านมีสิทธิตามกฎหมายคุ้มครองข้อมูลส่วนบุคคลในการดำเนินการ ดังต่อไปนี้
            </p>
            <ul>
                <li>
                    <p><u>สิทธิในการเพิกถอนความยินยอม</u> ท่านมีสิทธิขอเพิกถอนความยินยอมที่ให้ไว้แก่บริษัท ในการเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคลเมื่อใดก็ได้ เว้นแต่การเพิกถอนความยินยอมจะมีข้อจำกัดโดยกฎหมายหรือสัญญาที่ให้ประโยชน์แก่ท่าน ทั้งนี้ การถอนความยินยอมจะไม่ส่งผลกระทบต่อการประมวลผลข้อมูลส่วนบุคคลที่ท่านได้ให้ความยินยอมแก่บริษัทก่อนหน้าแล้วโดยชอบด้วยกฎหมาย</p>
                </li>
                <li>
                    <p><u>สิทธิในการเข้าถึงข้อมูลส่วนบุคคล</u> ท่านมีสิทธิขอเข้าถึงและขอรับสำเนาข้อมูลส่วนบุคคลของท่านซึ่งอยู่ในความรับผิดชอบของบริษัท รวมถึงขอให้บริษัท เปิดเผยถึงการได้มา ซึ่งข้อมูลส่วนบุคคลดังกล่าวที่ท่านไม่ได้ให้ความยินยอม</p>
                </li>
                <li>
                    <p><u>สิทธิในการให้ส่งหรือโอนข้อมูลส่วนบุคคล</u> ในกรณีที่บริษัทได้ทำให้ข้อมูลส่วนบุคคลนั้นอยู่ในรูปแบบที่สามารถอ่านหรือใช้งานโดยทั่วไปได้ด้วยเครื่องมือหรืออุปกรณ์ที่ทำงานได้โดยอัตโนมัติและสามารถใช้หรือเปิดเผยข้อมูลส่วนบุคคลได้ด้วยวิธีการอัตโนมัติ ท่านมีสิทธิขอรับข้อมูลส่วนบุคคลจากบริษัทได้ รวมทั้งมีสิทธิขอให้บริษัทส่งหรือโอนข้อมูลส่วนบุคคลในรูปแบบดังกล่าวไปยังผู้ควบคุมข้อมูลส่วนบุคคลอื่นได้ตามที่กฎหมายกำหนด</p>
                </li>
                <li>
                    <p><u>สิทธิในการคัดค้านการเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคล</u> ท่านมีสิทธิในการคัดค้านการประมวลผลข้อมูลที่เกี่ยวกับท่านสำหรับกรณีการเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคลได้ตามที่กฎหมายกำหนด</p>
                </li>
                <li>
                    <p><u>สิทธิในการลบข้อมูลส่วนบุคคล</u> ท่านมีสิทธิขอให้บริษัทลบหรือทำลายหรือทำให้ข้อมูลส่วนบุคคลเป็นข้อมูลที่ไม่สามารถระบุตัวตนได้ด้วยเหตุตามที่กฎหมายกำหนด</p>
                </li>
                <li>
                    <p><u>สิทธิในการระงับการใช้ข้อมูลส่วนบุคคล</u> ท่านมีสิทธิขอให้บริษัทระงับการใช้ข้อมูลของท่านด้วยเหตุตามที่กฎหมายกำหนด</p>
                </li>
                <li>
                    <p><u>สิทธิในการร้องเรียน</u> ท่านมีสิทธิในการร้องเรียนต่อพนักงานเจ้าหน้าที่ผู้มีอำนาจตามกฎหมายคุ้มครองข้อมูลส่วนบุคคลเมื่อบริษัทฝ่าฝืนหรือไม่ปฏิบัติตามกฎหมายคุ้มครองข้อมูลส่วนบุคคลได้</p>
                </li>
            </ul>
            <p>หากท่านมีความประสงค์จะใช้สิทธิดังกล่าว ท่านสามารถติดต่อขอใช้สิทธิได้ที่ช่องทางการติดต่อที่ระบุในนโยบายนี้</p>
        </li>

        <li>
            <p><strong>มาตรการในการรักษาความมั่นคงปลอดภัยของข้อมูลส่วนบุคคล</strong></p>
            <p>บริษัทได้กำหนดให้มีมาตรการรักษาความมั่นคงปลอดภัยที่เหมาะสมและเข้มงวดในการรักษาความมั่นคงปลอดภัยของข้อมูลส่วนบุคคล เพื่อป้องกันการสูญหาย เข้าถึง ใช้ เปลี่ยนแปลง แก้ไข หรือเปิดเผยข้อมูลส่วนบุคคลโดยปราศจากอำนาจหรือโดยมิชอบ
            </p>
            <p>กรณีที่บริษัทมอบหมายให้บุคคลอื่นดำเนินการประมวลผลข้อมูลส่วนบุคคลตามคำสั่งหรือในนามของบริษัท บริษัทจะกำกับดูแลบุคคลดังกล่าวอย่างเหมาะสมเพื่อให้มั่นใจได้ว่าบุคคลดังกล่าวจะรักษาความมั่นคงปลอดภัยของข้อมูลส่วนบุคคลของท่านตามกฏหมายคุ้มครองข้อมูลส่วนบุคคล
            </p>
        </li>

        <li>
            <p><strong>รายละเอียดการติดต่อ</strong></p>
            <p>ในกรณีที่มีข้อสงสัยหรือต้องการสอบถามรายละเอียดเพิ่มเติมเกี่ยวกับการคุ้มครองข้อมูลส่วนบุคคลของท่าน การเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลของท่าน การใช้สิทธิของท่าน หรือมีข้อร้องเรียนใด ๆ ท่านสามารถติดต่อบริษัท ได้ตามช่องทางดังต่อไปนี้
            </p>
            <p><strong>อีเมล:</strong> <a href="mailto:dpo@newsoft.co.th">dpo@newsoft.co.th</a>
            </p>
            <p><strong>ที่อยู่:</strong> 61/277 ถนนพระราม 9 แขวงห้วยขวาง เขตห้วยขวาง กรุงเทพฯ 10310
            </p>
            <p><strong>โทรศัพท์:</strong> 0-2246-1122-4
            </p>
            <p><strong>เว็บไซท์:</strong> <a href="https://newsoft.co.th/" target="_blank">www.newsoft.co.th</a></p>
            <p>เนื่องจากนโยบายความเป็นส่วนตัวฉบับนี้ใช้สำหรับการใช้งานซอฟท์แวร์ของบริษัทเท่านั้น หากท่านใช้งานซอฟท์แวร์อื่น แม้จะเป็นการเรียกใช้ผ่านทางซอฟท์แวร์ของบริษัท การคุ้มครองข้อมูลส่วนบุคคลต่าง ๆ จะเป็นไปตามนโยบายความเป็นส่วนตัวของซอฟท์แวร์นั้นๆ ซึ่งไม่มีส่วนเกี่ยวข้องกับบริษัท
            </p>
        </li>

    </ol>
    </div>`,

  ch: `<div>
    <h2>隐私政策</h2>
    <ol>

        <li>
            <p><strong>我们的隐私声明</strong></p>
            <p>纽索夫特技术顾问公司（以下简称"公司"或"我们"）制定并公开本隐私政策，旨在说明我们如何处理客户、供应商及其他业务合作伙伴的个人数据，包括其企业实体的个人，如员工、联系人及董事，因为保护您的个人数据对我们至关重要。
            </p>
            <p>我们依据适用的个人数据保护法规处理您的个人数据，尤其是《个人数据保护法》佛历2562年（"PDPA"）。本隐私政策说明我们作为数据控制者如何收集、使用和披露您的个人数据。此外，我们会定期审查和更新本隐私政策，如有重大变更，我们将以适当方式通知您。
            </p>
        </li>

        <li>
            <p><strong>收集的个人数据</strong></p>
            <p>根据PDPA，个人数据是指与个人相关的任何信息，无论直接或间接能够识别该个人身份，但不包括已故人员的特定信息。
            </p>
            <p>我们收集以下个人数据，以实现本政策所述目的，并依据PDPA规定的合法依据进行处理。此外，我们可能依据PDPA特殊规定处理您的敏感性个人数据，包括宗教信仰和健康信息。我们直接向您收集个人数据，或可能通过招聘机构收集您的个人数据。
            </p>
            <ul>
                <li><strong>一般个人数据</strong>
                    <p>姓名、姓氏、电话号码、电子邮件、应用程序使用数据及设备信息。
                    </p>
                </li>
            </ul>
        </li>

        <li>
            <p><strong>处理个人数据的目的</strong></p>
            <p>公司根据您与公司之间的关系，出于以下各种目的收集、使用或披露您的个人数据：
            </p>
            <ul>
                <li>
                    <p>为您提供我们产品和服务的一般使用，包括与我们产品和服务相关的任何其他服务，例如发送电子邮件、打印报告等。
                    </p>
                </li>
                <li>
                    <p>分析我们产品和服务的使用情况，以确定使用目的、保障安全、协助客户，以及改进产品、服务和用户体验。
                    </p>
                </li>
            </ul>
        </li>

        <li>
            <p><strong>处理个人数据的法律依据</strong></p>
            <p>处理您个人数据的法律依据如下：
            </p>
            <ul>
                <li>
                    <p>法律要求时，须取得同意；</p>
                </li>
                <li>
                    <p>处理活动对于履行您与公司之间的合同义务所必需时；
                    </p>
                </li>
                <li>
                    <p>处理活动为追求公司合法利益所必需时；
                    </p>
                </li>
                <li>
                    <p>处理活动为履行我们的法律义务所必需时。</p>
                </li>
            </ul>

            <p>您有权随时通过我们在取得同意时单独指定的方式撤回您的同意。但是，您撤回同意不会影响在撤回前基于您同意合法进行的处理活动。</p>
            <p>如果提供个人数据是法定或合同要求，或订立合同的必要条件，以及不提供此类数据可能导致的后果，我们将单独通知您。</p>
        </li>

        <li>
            <p><strong>个人数据的保留期限</strong></p>
            <p>我们将在实现上述收集和处理您个人数据目的所必要的期限内保留您的个人数据。确定保留期限的具体标准包括：我们与您持续关系的持续时间、遵守适用法律、遵守法律规定以行使法律主张权利或抗辩法律主张，以及出于其他法律或商业原因保留个人数据的必要性。
            </p>
            <p>请放心，保留期届满后保留个人数据仅在必要情况下发生。当保留期届满或不再需要保留此类数据时（以较早者为准），我们将销毁或从我们的系统中删除此类数据。</p>
        </li>

        <li>
            <p><strong>个人数据的披露</strong></p>
            <p>我们可能依据PDPA将您的个人数据共享和披露给以下第三方，用于本隐私政策所述目的。公司将根据PDPA的要求，在必要时通知您并请求同意。
            </p>
            <ul>
                <li>
                    <p>子公司、关联公司及相关公司，用于商业目的</p>
                </li>
                <li>
                    <p>法律规定的政府机构或其他机构，包括有权官员，例如法院、警察、税务局、社会保障局、劳动保护和福利厅等。</p>
                </li>
                <li>
                    <p>代理商、服务提供商和/或分包商，用于其实施和程序，例如会计公司、税务顾问和工作许可代理公司。</p>
                </li>
            </ul>
            <p>由于上述共享和披露，在某些情况下，您的个人数据将通过执行标准数据保护条款（包括约束性公司规则或数据处理协议（如适用））转移给日本的接收公司，并采取适当保障措施，除非数据转移目的地国家具有个人数据保护委员会规定的适当数据保护标准，或我们依据PDPA取得您的同意。如您希望获得与这些保障措施相关的文件副本，请使用本隐私政策末尾的联系方式查询。
            </p>
        </li>

        <li>
            <p><strong>您作为数据主体的权利</strong></p>
            <p>您对我们收集和处理的个人数据拥有以下权利：
            </p>
            <ul>
                <li>
                    <p><u>获取数据处理信息的权利：</u>您有权从我们处获取与您相关的数据处理活动的所有必要信息。</p>
                </li>
                <li>
                    <p><u>访问个人数据的权利：</u>您有权从我们处确认是否正在处理与您相关的个人数据，如是，则有权访问该个人数据及某些相关信息。</p>
                </li>
                <li>
                    <p><u>更正或删除个人数据的权利：</u>您有权要求我们无不当延迟地更正与您相关的不准确个人数据，并有权要求我们补充任何不完整的个人数据。此外，在满足特定条件时，您有权要求我们无不当延迟地删除与您相关的个人数据。</p>
                </li>
                <li>
                    <p><u>限制处理个人数据的权利：</u>在满足特定条件时，您有权要求我们限制处理与您相关的个人数据。</p>
                </li>
                <li>
                    <p><u>反对处理个人数据的权利：</u>在满足特定条件时，您有权反对处理与您相关的个人数据。</p>
                </li>
                <li>
                    <p><u>个人数据可携带性：</u>在满足特定条件时，您有权以结构化、通用机器可读格式接收与您相关的个人数据。</p>
                </li>
                <li>
                    <p><u>不受自动化决策约束的权利：</u>在满足特定条件时，您有权不受仅基于数据的自动化决策（包括画像）约束，该决策对您产生任何法律或类似实质性影响。</p>
                </li>
            </ul>
            <p>如您打算行使上述任何权利，请使用本隐私政策末尾的联系方式查询。</p>
        </li>

        <li>
            <p><strong>数据保护安全措施</strong></p>
            <p>公司实施适当且严格的安全措施，以防止个人信息的未授权或非法丢失、访问、使用、更改、更正或披露。
            </p>
            <p>在公司委托任何第三方依据公司指示或代表公司处理您的个人信息的情况下，公司将对该第三方进行适当监督，以确保其依据PDPA保护您的个人信息。</p>
        </li>

        <li>
            <p><strong>联系方式</strong></p>
            <p><strong>电子邮件：</strong> <a href="mailto:dpo@newsoft.co.th">dpo@newsoft.co.th</a>
            </p>
            <p><strong>地址：</strong> 61/277 Rama 9 Road, Huay-Kwang, Bangkok 10310
            </p>
            <p><strong>电话：</strong> 0-2246-1122-4
            </p>
            <p><strong>网站：</strong> <a href="https://newsoft.co.th/" target="_blank">www.newsoft.co.th</a></p>
            <p>本政策仅适用于我们软件的使用。当您通过我们的软件链接至第三方软件时，个人信息保护将依据该软件的隐私政策执行，与本公司无关。
            </p>
        </li>

    </ol>
    </div>`,
};
